import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

//Components
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Button } from 'devextreme-react';

import ActionProgress from './../shared/ActionProgress';


// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    textField: {
        minWidth: '100%',
    },
});



const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
}))(MuiDialogActions);

class DisassociaLicenzaCmp extends Component {

    constructor(props) {
        super(props);

        this.submitState = this.submitState.bind(this);
        this.clearAll = this.clearAll.bind(this);
    }

    submitState() {
        const { selected_license, unlinkLicense, showDisassociaDialog } = this.props;

        showDisassociaDialog();

        unlinkLicense(selected_license.ProductKey);
    }

    // dopo aver completato la modifica, faccio reset e refresh della griglia licenze
    clearAll() {
        this.props.refreshLicenses(this.props.codiceUtente);
        this.props.resetFilters();
    }


    render() {
        const { classes, selected_license, isOpen, unlinkLicense,
            showDisassociaDialog, unlinkLicenseRequestStatus, unlinkLicenseErrorMessage } = this.props;

        return (
            <Fragment>
                <Dialog
                    onClose={showDisassociaDialog}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                >
                    <DialogTitle id="customized-dialog-title" onClose={showDisassociaDialog}>
                        Disassocia
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography gutterBottom >
                            {selected_license.HW_ID !== null && selected_license.HW_ID !== '' ?
                                'Confermi di voler disassociare la licenza selezionata dalla sua componente Hardware?'
                                :
                                'La licenza selezionata non è associata a nessuna componente Hardware.'
                            }
                        </Typography>
                    </DialogContent>
                    <DialogActions className={classes.alignCenter}>
                        {selected_license.HW_ID !== null && selected_license.HW_ID !== '' ?
                            <Button
                                width={120}
                                text="Disassocia"
                                type="default"
                                stylingMode="contained"
                                onClick={() => this.submitState()}
                            />
                            :
                            <Button
                                width={120}
                                text="Indietro"
                                type="normal"
                                stylingMode="outlined"
                                onClick={() => showDisassociaDialog()}
                            />
                        }
                    </DialogActions>
                </Dialog>

                <ActionProgress
                    status={unlinkLicenseRequestStatus}
                    errorMessage={unlinkLicenseErrorMessage}
                    tryAgainAction={() => unlinkLicense(selected_license.ProductKey)}
                    afterResolvedAction={() => this.clearAll()}
                />
            </ Fragment>
        );

    }
}

DisassociaLicenzaCmp.propTypes = {
    //unlinkLicense
    unlinkLicense: PropTypes.func.isRequired,
    unlinkLicenseRequestStatus: PropTypes.string.isRequired,
    unlinkLicenseErrorMessage: PropTypes.string,

    selected_license: PropTypes.shape({}),

    showDisassociaDialog: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,

    refreshLicenses: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

export default withStyles(styles)(DisassociaLicenzaCmp);